module.exports = __webpack_public_path__ + "img/logo-dne-token.52d0f905.svg";